var map = {
	"./china-cities.json": "df47",
	"./china-contour.json": "15a0",
	"./china.json": "0caa8",
	"./province/anhui.json": "5d23",
	"./province/aomen.json": "a215",
	"./province/beijing.json": "1ad9",
	"./province/chongqing.json": "0183",
	"./province/fujian.json": "2240",
	"./province/gansu.json": "8a38",
	"./province/guangdong.json": "ce78",
	"./province/guangxi.json": "60b8",
	"./province/guizhou.json": "3d1d",
	"./province/hainan.json": "4592",
	"./province/hebei.json": "0284",
	"./province/heilongjiang.json": "6e1b",
	"./province/henan.json": "6b66",
	"./province/hubei.json": "20fa",
	"./province/hunan.json": "42c8",
	"./province/jiangsu.json": "7b3e6",
	"./province/jiangxi.json": "ea37",
	"./province/jilin.json": "3a5a",
	"./province/liaoning.json": "6e18",
	"./province/neimenggu.json": "9c65",
	"./province/ningxia.json": "f0e0",
	"./province/qinghai.json": "a699",
	"./province/shandong.json": "d7ae",
	"./province/shanghai.json": "b814",
	"./province/shanxi.json": "d0ce",
	"./province/shanxi1.json": "6340",
	"./province/sichuan.json": "787a",
	"./province/taiwan.json": "48bd",
	"./province/tianjin.json": "0dea",
	"./province/xianggang.json": "3273",
	"./province/xinjiang.json": "722b",
	"./province/xizang.json": "e4e8",
	"./province/yunnan.json": "77e8",
	"./province/zhejiang.json": "5e7c",
	"./world.json": "2da2"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "d509";